import { Button, FormGroup, InputLabel, OutlinedInput } from '@mui/material'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { Container, ContainerForm, Title } from '../../styles/index.sty';
import AlertSnack from '../../components/Alert/AlertSnack'
import { useAuth } from '../../context/authContext'
import { useLists } from '../../context/listContext'
import { insertBrandData, updateBrandData } from '../../api/brands.api'

export const AddBrand = () => {
  const { config } = useAuth();
  const { fetchBrandsList } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const [ loading, setLoading ] = useState(false);
  const [open, setOpen] = useState(false);
  const [ response, setResponse ] = useState({});
  const formik = useFormik({
    initialValues: {
    brand_name: location?.state?.data?.brand_name,
    brand_description: location?.state?.data?.brand_description
    },
    onSubmit: async values => {
      setLoading(true);
      if (location?.state?.data) {
        const submit = await updateBrandData({...values, brand_id: location?.state?.data?.brand_id }, config);
        setResponse(submit);
        setOpen(true);
        fetchBrandsList();
        if(submit.status === "success") {
          navigate("/brands");
        }
      } else {
        const submit = await insertBrandData(values, config);
        setResponse(submit);
        fetchBrandsList();
        setOpen(true);
        if(submit.status === "success") {
          navigate("/brands");
        }
      }
    },
  });

  return (
    <>
    <Container>
      <Title variant='h5' className='w-[100%]'>Enter Brand Details.</Title>
      <ContainerForm>
      {open && <AlertSnack open={open} setOpen={setOpen} response={response} setLoading={setLoading} route="customers"/>}

      {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        :
      <div style={{width : "60%", margin: "auto"}} >
        <FormGroup>
          <InputLabel htmlFor="brand_name">Brand Name: </InputLabel>
          <OutlinedInput
            name="brand_name"
            placeholder="Enter Brand Name"
            id="brand_name"
            type="text"
            value={formik.values.brand_name}
            onChange={formik.handleChange}
            />
        </FormGroup><br/>
        <FormGroup>
          <InputLabel htmlFor="brand_description">Brand Description: </InputLabel>
          <OutlinedInput
            name="brand_description"
            placeholder="Enter Brand Description"
            id="brand_description"
            type="text"
            value={formik.values.brand_description}
            onChange={formik.handleChange}
            />
        </FormGroup>
        <div className='flex flex-row justify-between'>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={() => navigate("/brands")}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Back
          </Button>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={formik.handleSubmit}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Save & Continue
          </Button>
        </div>
        {/* <Button
          fullWidth
          type="button"
          variant='contained'
          color='info'
          onClick={logList}
          style={{
            margin: "1rem auto"
          }}
          >
          Click Me TO Check
        </Button> */}
        </div>}
      </ContainerForm>
    </Container>
    </>
  )
};